import { FC } from 'react';
import { NotificationsAssignments } from './NotificationsAssignments';
import { NotificationsAssignmentsMeetings } from './NotificationsAssignmentsMeetings';
import { typeMeeting } from '@monorepo/models';

type propsType = {
    meetings: typeMeeting[];
};

export const NotificationsMeetingAssignments: FC<propsType> = ({ meetings }) => {
    return (
        <NotificationsAssignments
            content={!!meetings.length ?
                meetings.map(m =>
                    <NotificationsAssignmentsMeetings key={m.id}
                        content={m.sections.filter(s => s.segments.some(se => se.assignments.some(a => a.user))).map(s =>
                            <div key={s.title}>
                                {/* <div className={`${i === 2 ? 'bg-green' : i === 3 ? 'bg-yellow' : i === 4 ? 'bg-general-red' : 'bg-general-blue'} fw-bold text-white py-1 ps-3 mt-3 mb-2`}>
                                    {s.title}
                                </div> */}
                                {s.segments.filter(se => se.assignments.some(a => a.user)).map(se =>
                                    <div key={se.subtitle} className={'ps-2 my-2'}>
                                        <div className={'mb-1'}>
                                            <span className={'fw-bold border-bottom'}>
                                                {se.subtitle}
                                            </span>
                                        </div>
                                        {se.assignments.filter(a => a.user).map(a =>
                                            <div key={`${a.room}_${a.isHelper}`}>
                                                <span className={'fw-bol'}>
                                                    -{a.room === '2' && 'SALA AUXILIAR '}{a.isHelper && 'COMO AYUDANTE '}{a.user!.name} {a.user!.lastName} | {a.user!.phoneNumber ? <span className={'bg-success'}>Teléfono: {a.user!.phoneNumber}</span> : <span className={'bg-general-red'}>Sin teléfono cargado - No recibirá notificaciones</span>}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        meeting={m}
                    />
                )
                :
                <>No hay ninguna asignación</>
            }
        />
    );
}
